import { ActionTypeMap, IActionConstructor } from './Action'
import { EndExamAction } from './Actions/EndExamAction'
import { ExitAction } from './Actions/ExitAction'
import { FinishQCAction } from './Actions/FinishQCAction'
import { FinishReviewAction } from './Actions/FinishReviewAction'
import { FinishTriagingAction } from './Actions/FinishTriagingAction'
import { SkipAction } from './Actions/SkipAction'
import { SubmitAction } from './Actions/SubmitAction'
import { SubmitAndExitAction } from './Actions/SubmitAndExitAction'
import { SubmitAttributeAction } from './Actions/SubmitAttributeAction'
import { SubmitExamAction } from './Actions/SubmitExamAction'
import { SubmitQCAction } from './Actions/SubmitQCAction'
import { SaveForLaterAction } from './Actions/SaveForLaterAction'

const BuiltInActions: IActionConstructor[] = [
    SubmitAction,
    ExitAction,
    SkipAction,
    SubmitAndExitAction,
    FinishReviewAction,
    FinishQCAction,
    SubmitQCAction,
    FinishTriagingAction,
    EndExamAction,
    SubmitExamAction,
    SubmitAttributeAction,
    SaveForLaterAction,
] as const

export class ActionRegistry {
    private actions: Map<string, IActionConstructor> = new Map()
    private static instance: ActionRegistry | null = null
    private constructor() {
        this.registerBuiltInActions()
    }

    static getInstance() {
        if (!ActionRegistry.instance) {
            ActionRegistry.instance = new ActionRegistry()
        }
        return ActionRegistry.instance
    }

    getAction(id: keyof ActionTypeMap) {
        return this.actions.get(id)
    }

    registerAction(action: IActionConstructor) {
        this.actions.set(action.Id, action)
    }

    unregisterAction(id: keyof ActionTypeMap) {
        this.actions.delete(id)
    }

    registerBuiltInActions() {
        BuiltInActions.forEach(action => this.registerAction(action))
    }
}
